export const GET_PRODUCTION_PLAN_INPUTS = 'GET_PRODUCTION_PLAN_INPUTS';
